// src/modules/application/utils/applicationDraft.ts
const KEY = "probationer_application_draft_v1";

export type DraftState = {
  applicationId?: string;
  currentStep: number; // 1..8
};

export function loadDraft(): DraftState {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : { currentStep: 1 };
  } catch {
    return { currentStep: 1 };
  }
}

export function saveDraft(draft: DraftState) {
  localStorage.setItem(KEY, JSON.stringify(draft));
}

export function clearDraft() {
  localStorage.removeItem(KEY);
}
